import PropTypes from "prop-types";

import StudentImage from "./StudentImage";
import T from "../translations/Translations";

import { gradeTranslator } from "../translations/Translations";

import "../../styles/StudentInfoBlock.scss";

/**
 * A component that will render a grey box with student information within
 * @name EprStudentInfoBlock
 * @constructor
 * @param {{}} studentInfo
 * @returns {JSX.Element}
 */
const EprStudentInfoBlock = ({ studentInfo }) => {
    const { address, firstName, gradeName, lastName, schoolName, studentNumber } = studentInfo;
    const gradeNumber = gradeTranslator(gradeName);
    return (
        <div className="student-block-container">
            <div className="photo-container">
                <StudentImage className="ms-2 rounded-3" height={165} studentInfo={studentInfo} width={165} />
            </div>
            <div className="student-info-container">
                <div className="student-name">{`${firstName} ${lastName} (${studentNumber})`}</div>
                <table>
                    <tbody>
                        <tr>
                            <td height={10} width={80}>
                                {/* Grade: */}
                                {T({ key: "Marquee_Grade" })}:
                            </td>
                            <td>
                                <i>{gradeNumber || "Unavailable"}</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
                <table>
                    <tbody>
                        <tr>
                            <td height={10} width={80} valign="middle">
                                {/* School: */}
                                {T({ key: "Marquee_School" })}:
                            </td>
                            <td>
                                <i>{schoolName || "Unavailable"}</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
                <table>
                    <tbody>
                        <tr>
                            <td width={80}>
                                {/* Address: */}
                                {T({ key: "Marquee_Address" })}:
                            </td>
                            <td>
                                <i>{address?.addressLine1}</i>
                            </td>
                        </tr>
                        {address?.addressLine2 && (
                            <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <i>{address?.addressLine2}</i>
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>&nbsp;</td>
                            <td>
                                <i>
                                    {address?.city}, {address?.state} {address?.zip}
                                </i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

EprStudentInfoBlock.propTypes = {
    studentInfo: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default EprStudentInfoBlock;
